// src/ImportRaces
import React, { useState } from "react";
import { XMLParser } from "fast-xml-parser";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Typography, Button } from "@mui/material";


const parser = new XMLParser({
    ignoreAttributes: false,
    attributeNamePrefix: "",
    parseTagValue: true,
    parseAttributeValue: true,
    trimValues: true,
});

function ImportRaces() {
    const [rows, setRows] = useState([]);
    const [raceInfo, setRaceInfo] = useState(null);

    const ensureArray = (val) => (Array.isArray(val) ? val : val ? [val] : []);
    const safeNumber = (v, fallback = 0) => {
        const n = parseFloat(v);
        return isNaN(n) ? fallback : n;
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            const jsonObj = parser.parse(e.target.result);

            const raceHeader = jsonObj?.SwissSkiResults?.Raceheader || {};
            const raceDetails = jsonObj?.SwissSkiResults?.AL_Race?.AL_Raceinfo || {};
            const rawData = jsonObj?.SwissSkiResults?.AL_Race?.AL_Data || [];

            const results = ensureArray(rawData);

            const appPenaltyW = safeNumber(raceDetails.AppPenaltyW, 0);
            const appPenaltyM = safeNumber(raceDetails.AppPenaltyM, 0);

            setRaceInfo({
                codex: raceHeader.Codex || "",
                date: raceHeader.Date || "",
                event: raceHeader.Event || "",
                place: raceHeader.Place || "",
                discipline: raceDetails.Discipline || "",
                appPenaltyW,
                appPenaltyM,
            });

            const formatted = results.map((a, index) => {
                const status = a.Status || "";
                const points = safeNumber(a.RPts, 0);

                const isCounted = status === "QLF";
                const penaltyBase = a.Sex === "D" ? appPenaltyW : appPenaltyM;
                const penaltyFinal = isCounted ? points + penaltyBase : null;

                return {
                    id: index + 1,
                    status,
                    rank: a.Rank || "",
                    bib: a.Bib || "",
                    pnr: a.PNr || "",
                    firstname: a.Firstname || "",
                    lastname: a.Lastname || "",
                    sex: a.Sex || "",
                    year: a.YearBirth || "",
                    category: a.Cat || "",
                    club: a.Club || "",
                    time: a.TimeTotal || "",
                    points,
                    penaltyFinal: penaltyFinal !== null ? penaltyFinal.toFixed(2) : "-",
                };
            });

            setRows(formatted);
        };

        reader.readAsText(file);
    };

    // Envoi vers serveur Express
    const handleSaveJSON = () => {
        const exportObj = {
            raceInfo,
            athletes: rows,
        };

        fetch("/save-json", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(exportObj),
        })
            .then((res) => res.json())
            .then((data) => {
                alert(`Fichier ${data.file} enregistré dans /data`);
            })
            .catch((err) => console.error("Erreur:", err));
    };

    const columns = [
        { field: "status", headerName: "Statut XML", width: 120 },
        { field: "rank", headerName: "Rang", width: 80 },
        { field: "bib", headerName: "Dossard", width: 90 },
        { field: "pnr", headerName: "PNr", width: 120 },
        { field: "firstname", headerName: "Prénom", width: 120 },
        { field: "lastname", headerName: "Nom", width: 120 },
        { field: "sex", headerName: "Sexe", width: 80 },
        { field: "year", headerName: "Année", width: 90 },
        { field: "category", headerName: "Catégorie", width: 110 },
        { field: "club", headerName: "Club", width: 170 },
        { field: "time", headerName: "Temps total", width: 140 },
        { field: "points", headerName: "RPts", width: 100, type: "number" },
        { field: "penaltyFinal", headerName: "Pénalité finale", width: 160 },
    ];

    return (
        <Box sx={{ height: 700, width: "100%", padding: 2 }}>
            <Typography variant="h4" gutterBottom>
                Résultats de course (XML + PNr + Pénalité finale)
            </Typography>
            {/* Composante pour importer et afficher le CSV */}

            <Box sx={{ display: "flex", gap: 2, marginBottom: 2 }}>
                <Button variant="contained" component="label">
                    Importer un fichier XML
                    <input type="file" accept=".xml" hidden onChange={handleFileUpload} />
                </Button>

                {rows.length > 0 && (
                    <Button variant="outlined" onClick={handleSaveJSON}>
                        Enregistrer dans /data
                    </Button>
                )}
            </Box>

            {raceInfo && (
                <Box sx={{ marginBottom: 2 }}>
                    <Typography variant="h6">Infos de la course</Typography>
                    <Typography><strong>Codex:</strong> {raceInfo.codex}</Typography>
                    <Typography><strong>Date:</strong> {raceInfo.date}</Typography>
                    <Typography><strong>Épreuve:</strong> {raceInfo.event} ({raceInfo.place})</Typography>
                    <Typography><strong>Discipline:</strong> {raceInfo.discipline}</Typography>
                    <Typography><strong>Pénalité Dames:</strong> {raceInfo.appPenaltyW}</Typography>
                    <Typography><strong>Pénalité Hommes:</strong> {raceInfo.appPenaltyM}</Typography>
                </Box>
            )}

            <DataGrid
                rows={rows}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[10, 20, 50]}
                checkboxSelection
                disableSelectionOnClick
            />
        </Box>
    );
}

export default ImportRaces;
